<template>
  <BaseDelete
    :entry="entry"
    @delete-open-action="loadServerEntry(entry.id)"
    @delete-confirm-action="destroyEntry"
    @delete-cancel-action="cancelAction"
    deleteTitle="Cancelamento de Parcela Recebida"
    deleteButtonLabel="Cancelar Recebimento"
    deleteConfirmButtonLabel="Confirmar Cancelamento de Parcela Recebida"
    :formErrors="formErrors"
    deleteIcon="mdi-cancel"
    ref="baseDelete"
    width="70%"
  >
    <p> Você tem certeza que deseja cancelar o recebimento desta parcela?</p>
    <!--  <b>{{this.loadedEntry.totalPrice  | formatCurrency }}</b> -->
    <div class="pl-5" v-if="this.loadedEntry">
      <p><b>Código:</b> {{this.loadedEntry.code}}</p>
      <p><b>Fornecedor:</b> {{(this.loadedEntry.payment && this.loadedEntry.payment.cashFlow) ? (this.loadedEntry.payment.cashFlow.customer ? this.loadedEntry.payment.cashFlow.customer.name : "") : ""}}</p>
      <p><b>Plano de Contas:</b> {{(this.loadedEntry.payment && this.loadedEntry.payment.cashFlow) ? (this.loadedEntry.payment.cashFlow.chart ? this.loadedEntry.payment.cashFlow.chart.name : "") : ""}}</p>
      <p><b>Conta Bancária:</b> {{this.loadedEntry.bankAccount ? this.loadedEntry.bankAccount.name : ""}}</p>
      <p><b>Data de Vencimento:</b> {{this.loadedEntry.dueDate | formatDate}}</p>
      <p><b>Valor:</b> {{this.loadedEntry.value | formatCurrency}}</p>
      <p><b>Data de Recebimento:</b> {{this.loadedEntry.paymentDate | formatDate}}</p>
      <p><b>Valor Recebido:</b> {{this.loadedEntry.totalPaidAmount | formatCurrency}}</p>

      <p v-if="loadedEntry && loadedEntry.isPartiallyPaid">
        <PaymentIndex
          :payments="loadedEntry.additionalPaymentsAttributes"
          :readOnly="true"
          modelType="CashInflowInstallment"
          :paymentsSummary="false"
          :containTopToolbar="false"
          :hasTableTitle="true"
          tableTitle="Recebimentos adicionais que serão removidos"
          @installment-update="loadServerEntry(entry.id)"
        />
      </p>
    </div>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";
import PaymentIndex from "@models/payments/index.vue"

export default {
  data () {
    return {
      error: null,
      loading: true,
      formErrors: [],
      loadedEntry: null
    }
  },
  components: {
    BaseDelete: BaseDelete,
    PaymentIndex: PaymentIndex
  },
  props: {
    entry: Object,
  },
  created() {
    // this.loadServerEntry(this.entry.id)
  },
  methods: {
    loadServerEntry: function(id) {
      // console.log(id);
      this.loadedEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_CASH_INFLOW_INSTALLMENT_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.loadedEntry = response.data.accountContext.cashInflowInstallment;
          // console.log("cashInflowInstallment edit", this.editableEntry);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    destroyServerEntry: function(installment) {
      this.loading = true;
        this.$apollo
          .mutate({
            mutation: CANCEL_INSTALLMENT_MUTATION,
            variables: {
              id: installment.id,
            }
          })
          .then(response => {
            var errors = response.data.cancelInstallmentPayment.errors
            if (errors.length){
              this.formErrors = errors
            } else {
              this.$emit("entry-destroyed", response.data.cancelInstallmentPayment.installment);
              this.$refs.baseDelete.closeDialog();
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
    },
    destroyEntry: function() {
      this.destroyServerEntry(this.entry);
    },
    cancelAction: function() {
      this.$emit('entry-canceled');
    }
  }
}
const LOAD_CASH_INFLOW_INSTALLMENT_QUERY = gql `
  query ($id: ID!) {
  accountContext {
    cashInflowInstallment(id: $id){
      id
      code
      payment {
        cashFlow {
          chart {
            name
          }
          customer {
            name
          }
        }
      }
      dueDate
      paymentDate
      paymentMethod {
        id
        name
      }
      bankAccountId
      bankAccount {
        id
        name
        nameWithBank
        currentBalance
        accountNumber
        agencyNumber
        bankAccountType {
          id
          name
        }
        bank {
          id
          name
          nameWithCode
        }
      }
      originalValue
      value
      interest
      penalty
      discount
      paidAmount
      totalPaidAmount
      isFullyPaid
      isPartiallyPaid
      observation
      parentObservation
      additionalPaymentsAttributes {
        id
        code
        bankAccountId
        paymentMethodId
        value
        initialDate
        installmentsIntervalId
        installmentsInterval {
          id
          description
          intervalInDays
        }
        paymentConditionId
        paymentCondition {
          id
          description
          numberOfInstallments
        }
        paymentMethod {
          id
          name
        }
        bankAccount {
          id
          name
        }
        installmentsAttributes {
          id
          value
          originalValue
          customCode
          dueDate
          code
          status
          statusKey
          statusColor
          paidAmount
          totalPaidAmount
          paymentDate
          bankAccount {
            id
            name
          }
        }
      }
      validations
      fullPaymentValidations
      partialPaymentValidations
    }
  }
}
`;

const CANCEL_INSTALLMENT_MUTATION = gql `
  mutation($id: ID!) {
    cancelInstallmentPayment(id: $id) {
      installment {
        id
        originalValue
        customCode
        dueDate
        code
        status
        statusKey
        statusColor
        paidAmount
        totalPaidAmount
        paymentDate
      }
      errors
    }
  }
`;
</script>

<style scoped></style>
